import { render, staticRenderFns } from "./CarDetail.vue?vue&type=template&id=95b9b72a&scoped=true&"
import script from "./CarDetail.vue?vue&type=script&lang=js&"
export * from "./CarDetail.vue?vue&type=script&lang=js&"
import style0 from "./CarDetail.vue?vue&type=style&index=0&id=95b9b72a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b9b72a",
  null
  
)

export default component.exports